<template>
  <DashboardTemplate :navMenu="true">
    <div v-loading="loading">
      <div class="text-left pd-b-3">
        <h2 class="mg-less">ข้อมูลผู้สอน</h2>
      </div>

      <div class="flex-display js-center ai-center pd-b-3">
        <div class="box-image">
          <avatar
            :rounded="false"
            :username="instructor?instructor.nameTH:''"
            :src="instructor && typeof instructor.profileImg != 'undefined' && instructor.profileImg != ''?`${urlImage}${instructorId}/${instructor.profileImg}`:''"
            :size="160"
          ></avatar>
        </div>
      </div>

      <InstructorView
        v-if="instructor"
        :email="instructor.email"
        :prefix="instructor.titleName"
        :nameTh="instructor.nameTH"
        :lastNameTh="instructor.surnameTH"
        :nameEn="instructor.nameEN"
        :lastNameEn="instructor.surnameEN"
        :phoneNumber="instructor.mobilephone"
        :position="instructor.position"
        :agency="instructor.institution.name"
        :address="instructor.institution.address"
        :subDistrict="instructor.institution.subdistrict"
        :district="instructor.institution.district"
        :province="instructor.institution.province"
        :postcode="instructor.institution.postcode"
      />
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import InstructorView from "@/components/instructor/InstructorView";
import { HTTP } from "@/service/axios.js";
import Avatar from "vue-avatar";

export default {
  components: {
    DashboardTemplate,
    InstructorView,
    Avatar
  },
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      instructorId: "",
      instructor: null,
      loading: true,
      urlImage: process.env.VUE_APP_BASE_URL_IMAGE,
    };
  },
  mounted() {
    this.setParams();
    this.fetchInstructorById();
  },
  methods: {
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.instructorId != "undefined") {
          this.instructorId = this.routeParams.instructorId;
        }
      }
    },
    fetchInstructorById() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`instructor/${this.instructorId}`)
        .then((res) => {
  
          if (res.data.success) {
            this.instructor = res.data.obj;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchInstructorById error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
  },
};
</script>
